import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { DeviceItemCardComponent } from '../device-item-card/device-item-card.component';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { DeviceResponseDto } from '../../models/device-response.interface';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { AreaItemCardComponent } from '../area-item-card/area-item-card.component';
import { ApiDeviceGroupResponseDto } from '@birco/rainmesh-api';

@Component({
  selector: 'app-devices-dashboard-card',
  imports: [
    CardComponent,
    DeviceItemCardComponent,
    IconComponent,
    TranslatePipe,
    RouterLink,
    AsyncPipe,
    MatTabGroup,
    MatTab,
    AreaItemCardComponent,
  ],
  templateUrl: './devices-dashboard-card.component.html',
  styleUrl: './devices-dashboard-card.component.scss',
})
export class DevicesDashboardCardComponent {
  @Input() isSystemRunning: boolean = true;
  @Input() devices$?: Observable<DeviceResponseDto[]>;
  @Input() deviceGroups$?: Observable<ApiDeviceGroupResponseDto[]>;
  @Output() triggerDeviceAction = new EventEmitter<{
    id: string;
    value: boolean;
  }>();
  @Output() triggerDeviceGroupAction = new EventEmitter<{
    id: string;
    value: boolean;
  }>();

  protected readonly RouteConstants = RouteConstants;

  onTriggerDeviceAction(evtData: { id: string; value: boolean }) {
    this.triggerDeviceAction.emit(evtData);
  }

  onTriggerDeviceGroupAction(evtData: { id: string; value: boolean }) {
    this.triggerDeviceGroupAction.emit(evtData);
  }
}
